import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  StatusBadge,
} from '@skylabs-digital/backoffice-kit';
import type { PrefixRule } from '../../schemas/app.schema';
import { ManagedByCacNotice } from '../shared/ManagedByCac';
import { formatBytes } from './AppList';

export function PrefixRulesCard({ rules, managed }: { rules: PrefixRule[]; managed: boolean }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Prefix rules</CardTitle>
        <CardDescription>
          Visibility, limits, TTL and image variants per path prefix.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        {managed ? <ManagedByCacNotice what="app" /> : null}
        {rules.length === 0 ? (
          <p className="text-sm text-muted-foreground">
            No prefix rules. Every upload must declare its visibility.
          </p>
        ) : (
          <ul className="divide-y divide-border">
            {rules.map((r) => (
              <li key={r.pattern} className="flex flex-wrap items-center gap-2 py-2 text-sm">
                <code className="font-mono text-xs">{r.pattern}</code>
                {r.visibility ? (
                  <StatusBadge tone={r.visibility === 'PUBLIC' ? 'warning' : 'info'}>
                    {r.visibility}
                  </StatusBadge>
                ) : null}
                {r.maxSizeBytes ? (
                  <span className="text-muted-foreground">max {formatBytes(r.maxSizeBytes)}</span>
                ) : null}
                {r.allowedMimeTypes ? (
                  <span className="text-muted-foreground">{r.allowedMimeTypes.join(', ')}</span>
                ) : null}
                {r.expiresAfterSeconds ? (
                  <span className="text-muted-foreground">ttl {r.expiresAfterSeconds}s</span>
                ) : null}
                {r.image ? (
                  <span className="text-muted-foreground">
                    variants:{' '}
                    {r.image.variants
                      .map(
                        (v) => `${v.name} ${v.width}${v.height ? `×${v.height}` : ''} ${v.format}`,
                      )
                      .join(' · ')}
                  </span>
                ) : null}
                {r.image?.extractGps ? (
                  <span className="text-muted-foreground">gps: extracted</span>
                ) : null}
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
